import React, { useEffect, useState } from 'react'
import { Form, Input } from 'antd'
import ModalComponent from './ModalComponent.jsx'
import LoadableButton from '../../buttons/LoadableButton.jsx'

export default function OTPModal({
    isOpen = false,
    setIsOpen,
    title = 'OTP Verification',
    message,
    width = 600,
    onSubmit,
    onResend,
    isLoading = false,
    loadingLabel = 'Verifying...',
    submitLabel = 'Verify',
    otpDuration = 120,
    formatTime = (t) => {
        const m = Math.floor(t / 60)
        const s = t % 60
        return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    },
    value,
    onChange,
    showLogo = true,
    logoLight = '/assets/logo/logo.png',

}) {
    const sharedProps = onChange ? { onChange } : {}
    const [timer, setTimer] = useState(0)
    const [form] = Form.useForm()
    const handleFinish = (values) => {
        if (onSubmit) onSubmit(values?.otp)
    }
    useEffect(() => {
        if (isOpen) {
            setTimer(otpDuration)
            form.resetFields(['otp'])
        }
    }, [isOpen, otpDuration])
    useEffect(() => {
        let id
        if (isOpen && timer > 0) {
            id = setInterval(() => setTimer((t) => (t > 0 ? t - 1 : 0)), 1000)
        }
        return () => { if (id) clearInterval(id) }
    }, [isOpen, timer])

    const handleResendClick = async () => {
        const result = onResend ? await onResend() : false
        if (result !== false) {
            setTimer(otpDuration)
            if (onChange) onChange("")
            form.resetFields(['otp'])
        }
    }

    return (
        <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} title={title} width={width}>
            <div className='sm:grid grid-cols-12 justify-center items-center'>
                <div className='md:col-span-12 col-span-5 flex flex-col justify-center items-center px-10 py-10 gap-6 w-full'>
                    {showLogo && (
                        <div className='flex justify-center'>
                            <img src='/assets/logo/logo.png'alt='logo' className='h-10 w-48 object-contain dark:hidden' />
                        </div>
                    )}
                    {message && (
                        <div className='text-center'>
                            <p className='text-[silver] text-sm font-medium auth-com mt-2'>{message}</p>
                        </div>
                    )}
                    <div className='w-full'>
                        <Form autoComplete='off' form={form} onFinish={handleFinish}>
                            <div className='w-full text-sm py-1'>
                                <div className='relative'>
                                    <Form.Item name='otp' rules={[{ required: true }]}>
                                        <Input.OTP {...sharedProps} value={value} style={{ width: '100%' }} />
                                    </Form.Item>
                                </div>
                            </div>
                            {typeof timer === 'number' && (
                                <div className='my-6 flex justify-center'>
                                    {timer === 0 ? (
                                        <button type='button' onClick={handleResendClick} className='text-sm primary font-bold'><span className=' font-normal'>Didn't receive it?</span> Resend OTP</button>
                                    ) : (
                                        <p>Resend OTP in {formatTime(timer)}</p>
                                    )}
                                </div>
                            )}
                            <div className='mt-8'>
                                <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text' lable={submitLabel} isLoading={isLoading} loadingLable={loadingLabel} />
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </ModalComponent>
    )
}